import { defineFeature } from "../../app/feature";
import { ClaimPage } from "./ClaimPage";
import { ClaimsPage } from "./ClaimsPage";

/** Claim explorer (task 4100.9; DESIGN-SPEC 9.3, 21): browse claims by run, lane, type, status, and
 * boundary, with exact source anchors. Read only. Owned by the evidence-engine lane. */
export default defineFeature({
  id: "claims",
  title: "Claims",
  routes: [
    { path: "/claims", Component: ClaimsPage },
    { path: "/claims/:claimId", Component: ClaimPage },
  ],
  nav: { label: "Claims", path: "/claims", section: "Claims", order: 10 },
  permissions: ["engagement.read"],
});
